import objectDeepCopy from 'utils/object-deep-copy';
import { pick as pickLodash } from 'lodash';

export function entityFactory(definition, source, pick = [])
{
    const response = objectDeepCopy({ ...definition, ...source });

    if (pick.length) return pickLodash(response, pick);

    return response;
}

export default entityFactory;
